import styled from 'styled-components';

import { RadioGroupLayout } from '.';

interface IRadioGroupContainer {
    layout?: RadioGroupLayout;
}

export const RadioGroupContainer = styled.div<IRadioGroupContainer>`
    display: flex;
    flex-direction: ${(props) =>
        props.layout === RadioGroupLayout.horizontal ? 'row' : 'column'};
`;

export const RadioGroupContainerLabel = styled.span`
    font-size: 0.875rem;
`;
